import {Query, gql} from 'apollo-angular';
import { Injectable } from '@angular/core';



@Injectable({
    providedIn: 'root'
})
export class BlockLossesQuery extends Query<any> {
    document = gql`
        query Turbines(
            $serialNav: Float!
            $fromTS: Float!
            $toTS: Float!
            $method: Int!
            $submethod: Int!
            $selection: [String!]
            $productionLossInput: Float
            $revenueLossInput: Float
            $provider: ForecastProvidersEnum
        ) {
            turbines(where: { serialNav: $serialNav }) {
                lossValues(
                    from: $fromTS
                    to: $toTS
                    method: $method
                    submethod: $submethod
                    selection: $selection
                    productionLossInput: $productionLossInput
                    revenueLossInput: $revenueLossInput
                    provider: $provider
                ) {
                    totalTheoProduction
                    totalActualProductionTurbine
                    totalActualProductionOtherTurbines
                    totalProductionLoss
                    totalRevenueLoss
                    totalRevenue
                    subBlocks
                }
            }
        }
    `;
}

/*
====== LIST OF LOSSES CALCULATION METHODS =====
method = 0 -> standard way to calculate rev and production losses
method = 1 -> Production losses popup -> Reference turbine option
method = 2 -> Production losses popup -> Power Curve option
method = 3 -> Production losses popup -> Reference Power Curve option ( TODO )
method = 4 -> Production losses popup -> Neighbouring windpark option
method = 5 -> Production losses popup -> Manual input (only to get turbine technical data)


====== LIST OF LOSSES CALCULATION SUBMETHODS ======
submethod = 0 -> no submethod selected
submethod = 1 -> Manufacturer power curve
submethod = 2 -> Historical power curve
*/

@Injectable({
    providedIn: 'root'
})
export class ProductionLossesActualProductionQuery extends Query<any> {
    document = gql`
        query Turbines($serialNav: Float!, $fromTS: Float!, $toTS: Float!) {
            turbines(where: { serialNav: $serialNav }) {
                _id
                code : codeDisplay
                serialNav
                type
                ratedPower
                serial
                productionLossCalculationActualProd(from: $fromTS, to: $toTS) {
                    _id
                    code
                    codeDisplay
                    windSpeed
                    production
                    availability
                    dataQuality
                }
            }
        }
    `;
}

@Injectable({
    providedIn: 'root'
})
export class ProductionLossesNeighbouringProductionQuery extends Query<any> {
    document = gql`
        query Turbines($serialNav: Float!, $fromTS: Float!, $toTS: Float!) {
            turbines(where: { serialNav: $serialNav }) {
                _id
                code : codeDisplay
                serialNav
                type
                ratedPower
                serial
                neighbouringWindparkData(from: $fromTS, to: $toTS) {
                    _id
                    name
                    distance
                    production
                    dataQuality
                }
            }
        }
    `;
}

@Injectable({
    providedIn: 'root'
})
export class ProductionLossesManufacturerTheoreticalProductionQuery extends Query<any> {
    document = gql`
        query Turbines($serialNav: Float!, $fromTS: Float!, $toTS: Float!) {
            turbines(where: { serialNav: $serialNav }) {
                _id
                code : codeDisplay
                serialNav
                type
                ratedPower
                serial
                productionLossCalculationManufacturerTheoProd(from: $fromTS, to: $toTS) {
                    _id
                    code
                    codeDisplay
                    windSpeed
                    production
                    availability
                    dataQuality
                }
            }
        }
    `;
}

@Injectable({
    providedIn: 'root'
})
export class ProductionLossesHistoricalTheoreticalProductionQuery extends Query<any> {
    document = gql`
        query Turbines($serialNav: Float!, $fromTS: Float!, $toTS: Float!) {
            turbines(where: { serialNav: $serialNav }) {
                _id
                code : codeDisplay
                serialNav
                type
                ratedPower
                serial
                productionLossCalculationHistoricalTheoProd(from: $fromTS, to: $toTS) {
                    _id
                    code
                    codeDisplay
                    windSpeed
                    production
                    availability
                    dataQuality
                }
            }
        }
    `;
}

@Injectable({
  providedIn: 'root'
})
export class ProductionLossesWaterfallQuery extends Query<any> {
  document = gql`
      query WaterfallProductionLossesQuery($serialNav: Float!, $fromTS: Float!, $toTS: Float!) {
          turbines(where: { serialNav: $serialNav }) {
              _id
              code : codeDisplay
              serialNav
              type
              ratedPower
              serial
              customWaterfallProductionLoss(from: $fromTS, to: $toTS) {
                totalTheoProduction
                totalActualProductionTurbine
                totalActualProductionOtherTurbines
                totalProductionLoss
                totalRevenueLoss
                totalRevenue
                subBlocks
                productionLossMethodObject {
                  selectedOption
                  selectedSuboption
                  selectedTurbines
                  selectedPark
                  waterfall
                }
              }
          }
      }
  `;
}

@Injectable({
    providedIn: 'root'
})
export class TurbineDataQuery extends Query<any> {
    document = gql`
        query Turbines($serialNav: Float!) {
            turbines(where: { serialNav: $serialNav }) {
                _id
                code
                codeDisplay
                serialNav
                type
                ratedPower
                serial
            }
        }
    `;
}
